@layer ui-kit;
@layer ui-kit {
  .ipafj10 {
    outline: 1px solid var(--_1qu8za24g);
  }
  .ipafj11 {
    outline: 1px solid var(--_1qu8za24k);
  }
  .ipafj12 {
    overflow: hidden;
    display: flex;
    flex-direction: column;
    align-items: center;
    border-radius: 12px;
    max-height: 220px;
    outline-offset: -1px;
  }
  .ipafj12:hover {
    outline-color: var(--_1qu8za24h);
  }
  .ipafj12:focus-within {
    outline-color: var(--_1qu8za24i);
  }
  .ipafj12:has(textarea:disabled) {
    pointer-events: none;
    background-color: var(--_1qu8za24f);
    color: var(--_1qu8za24c);
    outline: none;
  }
  .ipafj13 {
    font-weight: 400;
    font-size: 14px;
    line-height: 1.3;
    letter-spacing: -0.01em;
    padding: 12px 16px;
    scrollbar-gutter: stable;
    resize: none;
    border: none;
    width: 100%;
    height: 100%;
    overflow-y: auto;
    outline: none;
    background-color: var(--_1qu8za24d);
  }
  .ipafj13::placeholder {
    color: var(--_1qu8za248);
  }
}